import React, { useRef } from 'react';
import Slider from 'react-slick';
import { Box, Container, Typography, Card, CardContent, Stack, IconButton } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import AjayKumarImg from '../assets/ajay_kumar.jpg';
import VasanthaImg from '../assets/vasantha.jpg';
import { useMediaQuery } from '@mui/material';

const testimonials = [
    {
        name: 'Ajay Kumar',
        role: '',
        image: AjayKumarImg,
        text: 'Our cooperation with QUALITY MARBLE began in 2007. QUALITY MARBLE began in 2007. QUALITY MARBLE’s professional stone experience, high standard quality control, and a full range of service cooperation.',
    },
    {
        name: 'Vasantha',
        role: '',
        image: VasanthaImg,
        text: 'My story with stones started with KGF. I didn’t only have a business partner I also had one of my best friends Vasantha and his family as my family.',
    },
];

const TestimonialsSection = () => {
    const sliderRef = useRef(null);

    // Duplicate testimonials for smoother infinite scrolling
    const displayTestimonials = [...testimonials, ...testimonials, ...testimonials];

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        responsive: [
            {
                breakpoint: 900,  // covers tablets and below
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,  // covers mobile
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));

    return (
        <Box sx={{ bgcolor: '#414141', py: isMobile ? 4 : 6, color: 'white' }}>
            <Container>
                <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    justifyContent="space-between"
                    alignItems={{ xs: 'center', md: 'flex-end' }}
                    sx={{ mb: { xs: 4, md: 6 }, textAlign: { xs: 'center', md: 'left' } }}
                >
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: { xs: 'center', md: 'flex-start' }
                    }}>
                        <Stack direction="row" alignItems="center" spacing={0} sx={{ mb: 1 }}>
                            <Box sx={{
                                display: 'inline-block',
                                width: 15,
                                height: 15,
                                bgcolor: '#5c9bd8',
                                border: '5px solid #d3dee4',
                                borderRadius: '15px',
                                mr: '9px'
                            }} />
                            <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 600, textTransform: 'uppercase', fontSize: '0.875rem' }}>
                                Testimonials
                            </Typography>
                        </Stack>
                        <Typography variant={isMobile ? "h4" : "h3"} sx={{ fontWeight: 700, color: 'white', mb: { xs: 2, md: 0 } }}>
                            What Clients Saying
                        </Typography>
                        <Box sx={{ width: 60, height: 4, bgcolor: 'primary.main', mt: { xs: 1, md: 2 }, mb: { xs: 3, md: 0 } }} />
                    </Box>
                    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                        <IconButton
                            onClick={() => sliderRef.current?.slickPrev()}
                            sx={{
                                bgcolor: 'black',
                                color: 'white',
                                borderRadius: 1,
                                '&:hover': { bgcolor: '#333' },
                                width: 48,
                                height: 48
                            }}
                        >
                            <ArrowBackIosNewIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                            onClick={() => sliderRef.current?.slickNext()}
                            sx={{
                                bgcolor: 'black',
                                color: 'white',
                                borderRadius: 1,
                                '&:hover': { bgcolor: '#333' },
                                width: 48,
                                height: 48
                            }}
                        >
                            <ArrowForwardIosIcon fontSize="small" />
                        </IconButton>
                    </Box>
                </Stack>

                <Box sx={{
                    mx: { xs: 0, md: -2 },
                    overflow: 'hidden',
                    width: 'auto',
                    '& .slick-list': {
                        overflow: 'hidden',
                        margin: 0,
                    }
                }}>
                    <Slider ref={sliderRef} {...settings}>
                        {displayTestimonials.map((item, index) => (
                            <Box key={index} sx={{ px: { xs: 1, md: 2 }, pb: 2 }}>
                                <Card sx={{
                                    display: 'flex',
                                    flexDirection: { xs: 'column', md: 'row' },
                                    borderRadius: 2,
                                    bgcolor: 'white',
                                    overflow: 'hidden',
                                    height: '100%',
                                    minHeight: 300,
                                    margin: '0 auto',
                                    maxWidth: { xs: '100%', md: 'none' } // Ensure full width on mobile
                                }}>
                                    {/* Image Section */}
                                    <Box sx={{
                                        width: { xs: '100%', md: '40%' },
                                        minHeight: { xs: 'auto', md: 'auto' },
                                        position: 'relative',
                                        py: { xs: 1.5, md: 5 },
                                        px: { xs: 1.5, md: 3.5 },
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}>
                                        <img
                                            src={item.image}
                                            alt={item.name}
                                            style={{
                                                width: '150px',
                                                height: '150px',
                                                objectFit: 'cover',
                                                borderRadius: '50%'
                                            }}
                                        />
                                    </Box>

                                    {/* Content Section */}
                                    <CardContent sx={{
                                        width: { xs: '100%', md: '60%' },
                                        p: { xs: 1, md: 4 },
                                        textAlign: { xs: 'center', md: 'left' },
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center'
                                    }}>
                                        <Typography variant="h5" sx={{ fontSize: isMobile ? '1rem' : '1.5rem', fontWeight: 700, color: 'text.primary', mb: 2 }}>
                                            {item.name}
                                        </Typography>
                                        <Typography variant="body1" sx={{ fontSize: isMobile ? '0.6rem' : '1rem', color: 'text.secondary', lineHeight: 1.6 }}>
                                            {item.text}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Box>
                        ))}
                    </Slider>
                </Box>
            </Container>
        </Box>
    );
};

export default TestimonialsSection;